import type { IssueTypeField } from '../getIssueTypeFields';

export const findJiraFieldByKey = (
  jiraSchema: IssueTypeField[],
  fieldKey: string
): IssueTypeField | undefined => {
  return jiraSchema.find(field => fieldKey === field.key);
};
